import React from 'react';
import Header from './components/Header';
import Footer from './components/Footer';
import { useTexts } from './data';

const NotFound = () => {
  const TEXTS = useTexts();

  return (
    <div
      className="container-fluid pb-2 animate__animated animate__fadeIn"
      data-component="NotFound"
    >
      <Header />
      <div className="card mt-3">
        <div className="card-body fs-mobile text-center">
          <div>
            <h2>{TEXTS.NOT_FOUND_TITLE}</h2>
            <p>{TEXTS.NOT_FOUND_MESSAGE}</p>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default NotFound;
